import React, { FunctionComponent, ReactNode } from "react";
import { 
  TableHead, 
  TableBody, 
  TableRow, 
  TableCell 
} from "@mui/material";
import styles from "./PaginatedTable.module.css"; 
// Utilizing existing table styles, or we could pass styles/classes as props

export interface ColumnDef {
    id: string;
    label: string;
    style?: React.CSSProperties;
    className?: string;
    align?: 'left' | 'center' | 'right' | 'justify' | 'inherit';
}

interface DynamicTableProps {
    columns: ColumnDef[];
    children: ReactNode; // This will be the TableBody content (rows)
}

const DynamicTable: FunctionComponent<DynamicTableProps> = ({ columns, children }) => {
  return (
    <>
        <TableHead className={styles.tableHeader}>
            <TableRow>
                {columns.map((col) => (
                    <TableCell 
                        key={col.id} 
                        className={col.className || styles.headerCell} 
                        style={col.style}
                        align={col.align}
                    >
                        {col.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
        <TableBody>
            {children}
        </TableBody>
    </>
  );
};

export default DynamicTable;
